import { SMHeader, StaticContext } from '@sm/webassets';
import React, { useContext, useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import makeLinksStatic from '~app/helpers/makeLinksStatic';
import DeveloperWebNavHeader from '../DeveloperWebNavHeader';

const portedPages = [
  '/',
  '/home/?ut_source=header',
  '/api/v3/',
  '/api/v3/?ut_source=header',
  '/faq/',
  '/faq/?ut_source=header',
];

const useStyles = createUseStyles({
  headerPlaceholderSabeus: {
    height: '48px',
    width: '100%',
    background: '#00BF6F',
  },
  headerPlaceholderBlack: {
    height: '48px',
    width: '100%',
    background: '#404040',
  },
});

const fixLinks = domain => {
  const header = document.getElementsByTagName('header')[0];
  if (header) {
    const headerLinks = [...header.getElementsByTagName('a')];
    headerLinks.forEach(headerLink => {
      const headerLinkHref = headerLink.getAttribute('href');
      if (!headerLinkHref.startsWith('http') && !headerLinkHref.startsWith('/developer')) {
        const headerLinkElement = headerLink;
        headerLinkElement.href = portedPages.includes(headerLinkHref)
          ? `/developer${headerLinkHref}`
          : `https://developer.${domain}.com${headerLinkHref}`;
      }
    });
  }
};

const fixSubdomainLinks = domain => {
  const mobileButtons = document.querySelectorAll('header [class^="mobileNavBoxFull"] > button');
  if (mobileButtons.length) {
    mobileButtons.forEach(mobileButton => {
      mobileButton.addEventListener('click', () => {
        setTimeout(() => {
          fixLinks(domain);
        });
      });
    });
  }
};

const fixAccountLinks = (domain, subdomain) => {
  let tryAttachCount = 0;
  const attachAccountAction = setInterval(() => {
    const accountButton = document.querySelectorAll('header [class^="navBarBox"] button');
    if (accountButton[0]) {
      clearInterval(attachAccountAction);
      accountButton[0].addEventListener('click', () => {
        setTimeout(() => {
          const menuItems = document.querySelectorAll('header [class^="navBarBox"] [class^="wrenchList"] a');
          if (menuItems) {
            makeLinksStatic([...menuItems], domain, subdomain);
          }
        });
      });
      tryAttachCount += 1;
    }
    if (tryAttachCount > 10) {
      clearInterval(attachAccountAction);
    }
  }, 100);
};

const ModernHeader = () => {
  const {
    environment: { subdomain, domain },
    user,
    locale: { isEUDC },
  } = useContext(StaticContext);
  const { headerPlaceholderSabeus, headerPlaceholderBlack } = useStyles();

  const [postRenderHeader, setPostRenderHeader] = useState(false);

  useEffect(() => {
    setPostRenderHeader(true);
  }, []);

  useEffect(() => {
    // code for modifying header while testing on /developer path for mobile/tablet
    if (postRenderHeader) {
      if (subdomain !== 'developer' && subdomain !== 'developer.eu') {
        fixSubdomainLinks(domain);
      } else {
        fixAccountLinks(domain, subdomain);
      }
    }
  }, [domain, subdomain, postRenderHeader]);

  useEffect(() => {
    // code for modifying header while testing on /developer path
    if (subdomain !== 'developer' && subdomain !== 'developer.eu') {
      setTimeout(() => {
        fixLinks(domain);
      });
    }
  }, [domain, subdomain]);

  return (
    <>
      <If condition={user.isAuthenticated}>
        <If condition={postRenderHeader}>
          <SMHeader
            lang="en-US"
            isEUDC={isEUDC}
            user={user}
            isUserAuthenticated={user.isAuthenticated}
            wrenchVariant="developer"
          />
        </If>
        <If condition={!postRenderHeader}>
          <div className={headerPlaceholderBlack} />
        </If>
      </If>
      <If condition={!user.isAuthenticated}>
        <If condition={postRenderHeader}>
          <DeveloperWebNavHeader />
        </If>
        <If condition={!postRenderHeader}>
          <div className={headerPlaceholderSabeus} />
        </If>
      </If>
    </>
  );
};

export default ModernHeader;
